/**
 * @file: utils.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import {
  MaterialType,
  QuotationItemType,
  SiteInspectionType,
} from '@euler/model/enum';
import invariant from 'tiny-invariant';

export const keyOfIssue = (issue: {
  isCustomIssue?: boolean;
  inspectionType: SiteInspectionType;
  title: string;
  siteId?: number | null;
  itemId?: number | null;
}) => {
  invariant(issue != null, 'issue is required');
  const { isCustomIssue, inspectionType, title, siteId, itemId } = issue;
  return isCustomIssue
    ? ['custom_issue', inspectionType, title, siteId ?? 0].join(':')
    : ['standard_issue', inspectionType, title, siteId ?? 0, itemId ?? 0].join(
        ':',
      );
};

export const keyOfItem = (x: {
  type: QuotationItemType;
  name: string;
  itemNo?: string | null;
  materialType?: MaterialType | null;
  brandName?: string | null;
}) =>
  x.type === QuotationItemType.Construction
    ? [x.type, x.name, x.itemNo ?? ''].join(':')
    : (x.itemNo
        ? [x.type, x.name, x.itemNo]
        : [x.type, x.name, x.materialType ?? '', x.brandName ?? '']
      ).join(':');
